import React, { useCallback, useState } from 'react';
import { message } from 'antd';
import { Button } from 'ui-kit';
import { getOwnerPayoutSplitExport, IOwnerPayoutSplitExport } from 'api/owner_sdk';
import { downloadListOfListsAsCSV } from 'utils/csv';
import dayjs from 'dayjs';

export interface IPayoutSplitExportButton {
  startDate: Date;
  endDate: Date;
}

const PayoutSplitExportButton = ({ startDate, endDate }: IPayoutSplitExportButton) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleExport = useCallback(() => {
    setIsLoading(true);

    getOwnerPayoutSplitExport({
      startDate,
      endDate,
    })
      .then((data: IOwnerPayoutSplitExport) => {
        const { stores, all_recipients, grand_total, totals_per_recipient } = data;

        const headers = ['Store Name', 'Total', ...all_recipients];

        const storeRows = stores.map((store) => {
          const row: Array<string | number> = [
            store.store_name,
            Number(store.total_amount).toFixed(2),
          ];

          const splits = store.custom_store_splits || {};

          all_recipients.forEach((recipientName) => {
            const amount = splits[recipientName];

            if (amount !== undefined && amount !== null && !isNaN(Number(amount))) {
              row.push(Number(amount).toFixed(2));
            } else {
              row.push('');
            }
          });

          return row;
        });

        const totalsRow = [
          'Totals',
          Number(grand_total).toFixed(2),
          ...all_recipients.map((name) => Number(totals_per_recipient[name] || 0).toFixed(2)),
        ];

        const dataForCSV = [headers, ...storeRows, [], totalsRow];

        downloadListOfListsAsCSV({
          data: dataForCSV,
          filename: `Store Payout Split - ${dayjs(startDate).format('MMMM YYYY')}.csv`,
        });
      })
      .catch((err) => {
        message.error(err?.message || 'Failed to export payout split report. Please try again.');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [startDate, endDate]);

  return (
    <Button variant="contained" onClick={handleExport} loading={isLoading} disabled={isLoading}>
      Export Split Report
    </Button>
  );
};

export default PayoutSplitExportButton;
